module.exports = __webpack_public_path__ + "static/media/home_banner_3.d3203e1b.jpg";